// extracted by mini-css-extract-plugin
module.exports = {"text":"Forbidden_text__3kOJP","divider":"Forbidden_divider__eKmgu"};